import { render, staticRenderFns } from "./ActivateView.vue?vue&type=template&id=7a2f2284&"
import script from "./ActivateView.vue?vue&type=script&lang=js&"
export * from "./ActivateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports